import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';

// QSL Kartı Ayarları (Koordinatlar ve Stil)
const QSL_CONFIG = {
  template: '/images/qsl_template.jpg', // Şablon resim yolu (public klasöründe olmalı)
  width: 1654, // Şablon resmin genişliği (px)
  height: 1063, // Şablon resmin yüksekliği (px)
  fields: {
    callsign: { x: 550, y: 815, fontSize: '95px', color: '#000', font: 'Arial' },
    date: { x: 110, y: 970, fontSize: '50px', color: '#000', font: 'Arial' },
    time: { x: 370, y: 970, fontSize: '50px', color: '#000', font: 'Arial' },
    band: { x: 905, y: 970, fontSize: '50px', color: '#000', font: 'Arial' },
    mode: { x: 675, y: 970, fontSize: '50px', color: '#000', font: 'Arial' },
    freq: { x: 1155, y: 970, fontSize: '50px', color: '#000', font: 'Arial' },
    rst: { x: 1468, y: 970, fontSize: '50px', color: '#000', font: 'Arial' }
  }
};

const Home = () => {
  const { t } = useTranslation();
  const [qsos, setQsos] = useState([]);
  const [stats, setStats] = useState(null);
  const [error, setError] = useState(null);
  const [searchCallsign, setSearchCallsign] = useState('');
  const [searchResults, setSearchResults] = useState(null);
  const [searchLoading, setSearchLoading] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const [previewQso, setPreviewQso] = useState(null);
  const [onAirStatus, setOnAirStatus] = useState(null);

  useEffect(() => {
    const fetchQsos = async () => {
      try {
        const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname.startsWith('192');
        const apiUrl = isLocal ? `http://192.3.10.53:3001/api/qsos` : '/api/qsos';

        const response = await fetch(apiUrl);
        
        if (!response.ok) throw new Error(`HTTP Hata: ${response.status}`);

        const data = await response.json();
        console.log("Cloudlog Yanıtı:", data);
        
        let qsoList = [];
        // Backend artık { qsos: [...], stats: {...} } dönüyor
        if (data.qsos) {
          qsoList = data.qsos;
        }
        
        if (data.stats) {
          setStats(data.stats);
        }

        const newQsos = qsoList.map(q => ({
          date: q.date || (q.COL_TIME_ON ? q.COL_TIME_ON.split(' ')[0] : ''),
          time: q.time || (q.COL_TIME_ON ? q.COL_TIME_ON.split(' ')[1] : ''),
          callsign: q.callsign || q.call || q.COL_CALL,
          band: q.band || q.COL_BAND,
          gridsquare: q.gridsquare || q.grid || q.COL_GRIDSQUARE || q.COL_VUCC_GRIDSQUARE,
          mode: q.mode || q.COL_MODE,
          rst_rcvd: q.rst_rcvd || q.rst || q.COL_RST_RCVD
        }));

        if (newQsos.length === 0) {
          // API'den veri gelmediyse (senkronizasyon durumu), örnek verileri gösterelim
          setQsos([
            { date: '2025-01-20', time: '14:00', callsign: 'W1AW', band: '20m', gridsquare: 'FN31', mode: 'SSB', rst_rcvd: '59' },
            { date: '2025-01-20', time: '14:15', callsign: 'DL0D', band: '40m', gridsquare: 'JO31', mode: 'FT8', rst_rcvd: '-12' },
            { date: '2025-01-19', time: '20:30', callsign: 'JA1ABC', band: '15m', gridsquare: 'PM95', mode: 'CW', rst_rcvd: '599' },
            { date: '2025-01-19', time: '18:45', callsign: 'PY2XB', band: '10m', gridsquare: 'GG66', mode: 'SSB', rst_rcvd: '57' },
            { date: '2025-01-18', time: '09:00', callsign: 'VK3XYZ', band: '20m', gridsquare: 'QF22', mode: 'FT8', rst_rcvd: '-05' },
          ]);
        } else {
          setQsos(newQsos);
        }
        setError(null);

      } catch (error) {
        console.error('API Error:', error);
        setError(error.message);
      }
    };

    fetchQsos();
  }, []);

  useEffect(() => {
    const fetchOnAirStatus = async () => {
      try {
        const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname.startsWith('192');
        const apiUrl = isLocal ? `http://${window.location.hostname}:3001/api/on-air` : '/api/on-air';
        const response = await fetch(apiUrl, { cache: 'no-store' });
        if (response.ok) {
          const data = await response.json();
          setOnAirStatus(data);
        } else {
          setOnAirStatus(null);
        }
      } catch (error) {
        console.error('On Air Status fetch error:', error);
        setOnAirStatus(null);
      }
    };

    fetchOnAirStatus(); // İlk yüklemede çalıştır
    const interval = setInterval(fetchOnAirStatus, 60000); // Her 60 saniyede bir tekrarla

    return () => clearInterval(interval); // Component unmount olduğunda interval'ı temizle
  }, []);

  const handleQslSearch = async (e) => {
    e.preventDefault();
    if (!searchCallsign.trim()) return;

    setSearchLoading(true);
    setSearchResults(null);

    try {
      const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname.startsWith('192');
      const apiUrl = isLocal ? `http://192.3.10.53:3001/api/check_callsign` : '/api/check_callsign';

      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ callsign: searchCallsign })
      });

      const data = await response.json();
      console.log("Check Callsign Response:", data); // Hata ayıklama için
      setSearchResults(data);
    } catch (err) {
      console.error(err);
      setSearchResults({ error: true });
    } finally {
      setSearchLoading(false);
    }
  };

  const generateQslCard = (qso) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();
    
    img.onload = () => {
      canvas.width = QSL_CONFIG.width;
      canvas.height = QSL_CONFIG.height;
      
      // Şablonu çiz
      ctx.drawImage(img, 0, 0, QSL_CONFIG.width, QSL_CONFIG.height);
      
      // Yazıları çiz (Helper fonksiyon)
      const drawText = (text, config) => {
        ctx.font = `bold ${config.fontSize} ${config.font}`;
        ctx.fillStyle = config.color;
        ctx.fillText(text, config.x, config.y);
      };

      // Tarih ve Saati ayır
      const [dateStr, timeStr] = (qso.COL_TIME_ON || '').split(' ');

      drawText(qso.COL_CALL, QSL_CONFIG.fields.callsign);
      drawText(dateStr || '', QSL_CONFIG.fields.date);
      drawText(timeStr || '', QSL_CONFIG.fields.time);
      drawText(qso.COL_BAND, QSL_CONFIG.fields.band);
      
      // Mod uzunsa fontu küçült
      const modeConfig = { ...QSL_CONFIG.fields.mode };
      if (qso.COL_MODE && qso.COL_MODE.length > 3) {
        modeConfig.fontSize = '25px'; // Normalde 50px ise yarıya düşür
      }
      drawText(qso.COL_MODE, modeConfig);
      
      const freq = parseFloat(qso.COL_FREQ);
      drawText(freq ? freq.toFixed(4) : '', QSL_CONFIG.fields.freq);
      
      drawText(qso.COL_RST_SENT || '59', QSL_CONFIG.fields.rst);
      
      setPreviewImage(canvas.toDataURL('image/png'));
      setPreviewQso(qso);
    };
    
    img.onerror = () => alert('QSL Şablonu (qsl-card.jpg) bulunamadı!');
    img.src = QSL_CONFIG.template;
  };

  const closePreview = () => {
    setPreviewImage(null);
    setPreviewQso(null);
  };

  const downloadQsl = () => {
    if (previewImage && previewQso) {
      const link = document.createElement('a');
      link.download = `TA2GBO_QSL_${previewQso.COL_CALL}.png`;
      link.href = previewImage;
      link.click();
    }
  };

  return (
    <div className="home-container">
      <Helmet>
        <title>{t('navbar.home')} - TA2GBO</title>
      </Helmet>
      <div className="hero-section">
        <h1>{t('home.welcome')}</h1>
        <p>{t('home.subtitle')}</p>
        <div className="hero-btns">
          <a href="#qsl-search" className="btn btn-primary">{t('home.logbookBtn')}</a>
        </div>
      </div>

      {previewImage && (
        <div className="qsl-modal-overlay" onClick={closePreview}>
          <div className="qsl-modal-content" onClick={e => e.stopPropagation()}>
            <h3>{t('home.qslPreview')}</h3>
            <img src={previewImage} alt="QSL Preview" className="qsl-preview-img" />
            <div className="modal-actions">
              <button className="btn btn-primary" onClick={downloadQsl}>
                <i className="fas fa-download"></i> {t('home.downloadQsl')}
              </button>
              <button className="btn" onClick={closePreview} style={{background: '#eee', color: '#333'}}>
                {t('home.close')}
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="content-section">
        <div className="home-grid">
          <div className="home-text">
            <h2>{t('home.contentTitle')}</h2>
            <p>{t('home.contentBody1')}</p>
            <p>{t('home.contentBody2')}</p>

            <div id="qsl-search" className="qsl-search-section">
              <h3>{t('home.qslSearchTitle')}</h3>
              <form onSubmit={handleQslSearch} className="qsl-search-form">
                <input 
                  type="text" 
                  value={searchCallsign}
                  onChange={(e) => setSearchCallsign(e.target.value.toUpperCase())}
                  placeholder={t('home.callsignPlaceholder')}
                  className="qsl-input"
                />
                <button type="submit" className="btn btn-primary">{t('home.searchBtn')}</button>
              </form>
              
              {searchLoading && <p style={{marginTop: '15px'}}>Loading...</p>}
              
              {searchResults && (
                <div className="search-results" style={{marginTop: '20px'}}>
                  {searchResults.error || searchResults.message ? (
                    <p style={{color: '#d32f2f', fontWeight: 'bold'}}>
                      {searchResults.error || searchResults.message}
                    </p>
                  ) : (!searchResults.qsos || searchResults.qsos.length === 0) ? (
                    <p style={{color: '#d32f2f', fontWeight: 'bold'}}>{t('home.qslSearchNoResult')}</p>
                  ) : (
                    <div className="found-qsos">
                      <h4>{t('home.qslSearchResults')}</h4>
                      <ul className="qsl-results-list">
                        {(searchResults.qsos || []).map((qso, idx) => (
                          <li key={idx} className="qsl-result-item">
                            <div className="qsl-info">
                              <strong>{qso.COL_CALL}</strong> - {qso.COL_BAND} - {qso.COL_FREQ} - {qso.COL_MODE} - {qso.COL_TIME_ON}
                            </div>
                            <button className="btn-qsl" onClick={() => generateQslCard(qso)}>
                              <i className="fas fa-download"></i> {t('home.downloadQsl')}
                            </button>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              )}
            </div>

            <div className="qso-list">
              <h3>{t('home.lastQSOs')}</h3>
              {error && <p style={{ color: '#d32f2f', marginBottom: '1rem' }}>Veri yüklenemedi: {error}</p>}
              <div className="table-responsive">
                {qsos.length > 0 ? (
                  <table className="qso-table">
                    <thead>
                      <tr>
                        <th>{t('home.date')}</th>
                        <th>{t('home.time')}</th>
                        <th>{t('home.callsign')}</th>
                        <th>{t('home.band')}</th>
                        <th>{t('home.grid')}</th>
                        <th>{t('home.mode')}</th>
                        <th>{t('home.rst')}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {qsos.map((qso, index) => (
                        <tr key={index}>
                          <td>{qso.date}</td>
                          <td>{qso.time}</td>
                          <td>{qso.callsign || qso.call || qso.COL_CALL}</td> 
                          <td>{qso.band || qso.COL_BAND}</td>
                          <td>
                            {qso.gridsquare || '-'}
                          </td>
                          <td>{qso.mode || qso.COL_MODE}</td>
                          <td>{qso.rst_rcvd || qso.rst || qso.COL_RST_RCVD}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <p style={{ padding: '10px', color: '#666', fontStyle: 'italic' }}>
                    {error ? '' : 'Kayıt bulunamadı.'}
                  </p>
                )}
              </div>
            </div>
          </div>
          <div className="home-sidebar">
            <div className="sidebar-widget on-air-widget">
              <h3><i className="fas fa-satellite-dish"></i>{t('home.onAirStatus')}</h3>
              {(() => {
                if (!onAirStatus) {
                  return (
                    <div className="on-air-status off-air">
                      <i className="fas fa-microphone-slash" style={{fontSize: '2rem', marginBottom: '5px'}}></i>
                      {t('home.offAir')}
                    </div>
                  );
                }
                const spotTime = new Date(onAirStatus.time);
                const now = new Date();
                const minutesAgo = (now - spotTime) / (1000 * 60);

                if (minutesAgo <= 15) { // Son 15 dakika içinde spot varsa ON AIR
                  return (
                    <div className="on-air-status on-air">
                      <i className="fas fa-broadcast-tower" style={{fontSize: '2rem', marginBottom: '5px'}}></i>
                      ON AIR
                      <span className="on-air-details">{onAirStatus.frequency} MHz - {onAirStatus.mode}</span>
                    </div>
                  );
                } else {
                  return (
                    <div className="on-air-status off-air">
                      <i className="fas fa-microphone-slash" style={{fontSize: '2rem', marginBottom: '5px'}}></i>
                      {t('home.offAir')}
                    </div>
                  );
                }
              })()}
            </div>
            {stats && (
              <div className="sidebar-widget stats-widget">
                <h3><i className="fas fa-chart-bar"></i>{t('home.statsTitle')}</h3>
                <div className="stats-grid">
                  <div className="stat-item"><strong>{stats.Today}</strong><span>{t('home.statToday')}</span></div>
                  <div className="stat-item"><strong>{stats.month_qsos}</strong><span>{t('home.statMonth')}</span></div>
                  <div className="stat-item"><strong>{stats.year_qsos}</strong><span>{t('home.statYear')}</span></div>
                </div>
              </div>
            )}
            <div className="sidebar-widget">
              <h3><i className="fas fa-calculator"></i>{t('calculators.title')}</h3>
              <ul className="sidebar-links">
                <li><Link to="/calculators#gp">{t('calculators.gpTitle')}</Link></li>
                <li><Link to="/calculators#efhw">{t('calculators.efhwTitle')}</Link></li>
                <li><Link to="/calculators#dipole">{t('calculators.dipoleTitle')}</Link></li>
                <li><Link to="/calculators#cable">{t('calculators.cableLossTitle')}</Link></li>
                <li><Link to="/calculators#wavelength">{t('calculators.wavelengthTitle')}</Link></li>
              </ul>
            </div>
            <div className="sidebar-widget">
              <h3><i className="fas fa-link"></i>{t('usefulLinks.title')}</h3>
              <ul className="sidebar-links">
                <li><a href="https://www.radio.org.tr/" target="_blank" rel="noopener noreferrer">{t('usefulLinks.arc')}</a></li>
                <li><a href="https://www.kiyiemniyeti.gov.tr/" target="_blank" rel="noopener noreferrer">{t('usefulLinks.kegm')}</a></li>
              </ul>
            </div>
            <div className="sidebar-widget">
              <h3><i className="fas fa-sun"></i>{t('home.conditions')}</h3>
              <a href="https://www.hamqsl.com/solar.html" target="_blank" rel="noreferrer" title="Solar-Terrestrial Data">
                <img src="https://www.hamqsl.com/solarvhf.php" alt="Solar Data" className="solar-widget" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;